<template>
  <div>
    <p v-if="requiresDocumentUpload">{{ $t('LoanApplicationTimeline.ncDocumentsMissing') }}</p>
    <p v-else-if="newCoreEnabled && addressMissing">{{ $t('LoanApplicationTimeline.ncAddressMissing') }}</p>
    <p v-else class="small">{{ $t('LoanApplicationTimeline.youMayBeContacted') }}</p>
    <upload-document-photos-component v-if="shouldUploadDocuments" :application="application"/>
  </div>
</template>
<script>
import UploadDocumentPhotosComponent from '@shared/components/timeline/UploadDocumentPhotosComponent'
import settings from '@shared/settings'

export default {
  name: 'InReviewStageComponent',
  props: ['application'],
  components: { UploadDocumentPhotosComponent },
  computed: {
    shouldUploadDocuments() {
      const externalIdentityVerificationEnabled = settings.featureFlags.isIdentityVerificationEnabled()
      if (this.newCoreEnabled) {
        return !externalIdentityVerificationEnabled && (this.application.pendingReason === 'DOCUMENT' || this.application.uploadedPhotosCount > 0)
      }
      return !externalIdentityVerificationEnabled
    },
    newCoreEnabled() {
      return this.$configuration.newCoreEnabled
    },
    documentsMissing() {
      return this.application.pendingReason === 'DOCUMENT' && this.application.uploadedPhotosCount === 0
    },
    addressMissing() {
      return this.application.pendingReason === 'ADDRESS'
    },
    requiresDocumentUpload() {
      return this.newCoreEnabled && this.shouldUploadDocuments && this.documentsMissing
    }
  }
}
</script>
